import { render, staticRenderFns } from "./personInfoCard.vue?vue&type=template&id=7590a353&"
import script from "./personInfoCard.vue?vue&type=script&lang=js&"
export * from "./personInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports